// This directive shows an area graph representing the video inputs of a BoxCaster. Different
// colors are used to represent different input types.
angular.module('app.directives').directive('appBoxcasterVideoInputsGraph', $location =>
    ({
        require: '^^appBoxcasterGraph',
        restrict: 'E',
        scope: {
            statsData: '=',
            boxcasterId: '@'
        },
        controller($scope) {
            let STD_525_60 = 1;
            let STD_625_50 = 2;
            let STD_480i60 = 3;
            let STD_480p60 = 4;
            let STD_576p50 = 5;
            let STD_720p30 = 6;
            let STD_720p50 = 7;
            let STD_720p60 = 8;
            let STD_1080i50 = 10;
            let STD_1080i60 = 11;
            let STD_1080p30 = 12;
            let STD_1080p50 = 13;
            let STD_1080p60 = 14;
            let STD_480p30 = 15;
            let STD_576p25 = 16;
            let STD_720p25 = 17;
            let STD_1080p25 = 18;

            let ANALOG_STANDARDS = [STD_525_60, STD_625_50];
            let DIGITAL_STANDARDS = [STD_480i60, STD_480p60, STD_576p50, STD_720p30, STD_720p50, STD_720p60, STD_1080i50, STD_1080i60, STD_1080p30, STD_1080p50, STD_1080p60, STD_480p30, STD_576p25, STD_720p25, STD_1080p25];

            $scope.options = {
                renderer: 'area',
                interpolation: 'step-after',
                height: 40,
                min: 0,
                max: 1
            };
            $scope.series = [{
                name: 'Analog present but no standard',
                data: [],
                color: '#000000'
            }, {
                name: '525@60',
                data: [],
                color: '#000028'
            }, {
                name: '625@50',
                data: [],
                color: '#000050'
            }, {
                name: 'HDMI present but no standard',
                data: [],
                color: '#000078'
            }, {
                name: '480i60',
                data: [],
                color: '#0000a0'
            }, {
                name: '480p60',
                data: [],
                color: '#0000c8'
            }, {
                name: '576p50',
                data: [],
                color: '#0000f0'
            }, {
                name: '720p30',
                data: [],
                color: '#002800'
            }, {
                name: '720p50',
                data: [],
                color: '#005000'
            }, {
                name: '720p60',
                data: [],
                color: '#007800'
            }, {
                name: '1080i50',
                data: [],
                color: '#00a000'
            }, {
                name: '1080i60',
                data: [],
                color: '#00c800'
            }, {
                name: '1080p30',
                data: [],
                color: '#00f000'
            }, {
                name: '1080p50',
                data: [],
                color: '#280000'
            }, {
                name: '1080p60',
                data: [],
                color: '#500000'
            }, {
                name: '480p30',
                data: [],
                color: '#780000'
            }, {
                name: '576p25',
                data: [],
                color: '#a00000'
            }, {
                name: '720p25',
                data: [],
                color: '#c800000'
            }, {
                name: '1080p25',
                data: [],
                color: '#f000000'
            }];
            return $scope.$watch('statsData', function(newval, oldval) {
                if (newval != null) {
                    // TODO: This function is horribly inefficient.

                    // Search for requested adv7842 data targets
                    let adv7842data = {
                        composite_video_detected: newval['adv7842.composite.video-detected'],
                        composite_standard: newval['adv7842.composite.standard'],
                        hdmi_cable_detected: newval['adv7842.hdmi.cable-detected'],
                        hdmi_standard: newval['adv7842.hdmi.standard']
                    };

                    // Pluck just the times and sort them
                    let times = _.union(_.keys(adv7842data.composite_video_detected), _.keys(adv7842data.composite_standard), _.keys(adv7842data.hdmi_cable_detected), _.keys(adv7842data.hdmi_standard));
                    times.sort((a, b) => a - b);

                    // Now iterate through the times and construct series data for each series for each time
                    let seriesData = [
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        []
                    ];
                    _.each(times, function(t) {
                        t = parseInt(t);
                        let composite_video_detected = (adv7842data.composite_video_detected || [])[t];
                        let composite_standard = (adv7842data.composite_standard || [])[t];
                        let hdmi_cable_detected = (adv7842data.hdmi_cable_detected || [])[t];
                        let hdmi_standard = (adv7842data.hdmi_standard || [])[t];

                        seriesData[0].push({ x: t, y: ((composite_video_detected === 1) && !_.contains(ANALOG_STANDARDS, composite_standard) ? 1 : 0) });
                        seriesData[1].push({ x: t, y: (composite_standard === STD_525_60 ? 1 : 0) });
                        seriesData[2].push({ x: t, y: (composite_standard === STD_625_50 ? 1 : 0) });
                        seriesData[3].push({ x: t, y: ((hdmi_cable_detected === 1) && !_.contains(DIGITAL_STANDARDS, hdmi_standard) ? 1 : 0) });
                        seriesData[4].push({ x: t, y: (hdmi_standard === STD_480i60 ? 1 : 0) });
                        seriesData[5].push({ x: t, y: (hdmi_standard === STD_480p60 ? 1 : 0) });
                        seriesData[6].push({ x: t, y: (hdmi_standard === STD_576p50 ? 1 : 0) });
                        seriesData[7].push({ x: t, y: (hdmi_standard === STD_720p30 ? 1 : 0) });
                        seriesData[8].push({ x: t, y: (hdmi_standard === STD_720p50 ? 1 : 0) });
                        seriesData[9].push({ x: t, y: (hdmi_standard === STD_720p60 ? 1 : 0) });
                        seriesData[10].push({ x: t, y: (hdmi_standard === STD_1080i50 ? 1 : 0) });
                        seriesData[11].push({ x: t, y: (hdmi_standard === STD_1080i60 ? 1 : 0) });
                        seriesData[12].push({ x: t, y: (hdmi_standard === STD_1080p30 ? 1 : 0) });
                        seriesData[13].push({ x: t, y: (hdmi_standard === STD_1080p50 ? 1 : 0) });
                        seriesData[14].push({ x: t, y: (hdmi_standard === STD_1080p60 ? 1 : 0) });
                        seriesData[15].push({ x: t, y: (hdmi_standard === STD_480p30 ? 1 : 0) });
                        seriesData[16].push({ x: t, y: (hdmi_standard === STD_576p25 ? 1 : 0) });
                        seriesData[17].push({ x: t, y: (hdmi_standard === STD_720p25 ? 1 : 0) });
                        return seriesData[18].push({ x: t, y: (hdmi_standard === STD_1080p25 ? 1 : 0) });
                    });

                    // Clear and apply data to the actual series
                    return _.each($scope.series, function(s, idx) {
                        s.data.length = 0;
                        return Array.prototype.push.apply(s.data, seriesData[idx].sort((a, b) => a.x - b.x));
                    });
                }
            });
        },

        link(scope, element, attrs, appBoxcasterGraph) {
            return appBoxcasterGraph.registerGraphWidthCallback(newWidth =>
                scope.$apply(() => scope.options.width = newWidth)
            );
        },

        template: "<app-rickshaw rickshaw-options=\"options\" rickshaw-series=\"series\"></app-rickshaw>"
    }));


// WEBPACK FOOTER //
// ./directives/boxcaster_video_inputs_graph.js